import { render, staticRenderFns } from "./Call-Stats-Dialog.vue?vue&type=template&id=065eaff0&"
import script from "./Call-Stats-Dialog.vue?vue&type=script&lang=js&"
export * from "./Call-Stats-Dialog.vue?vue&type=script&lang=js&"
import style0 from "./Call-Stats-Dialog.vue?vue&type=style&index=0&id=065eaff0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports